/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppPropsResponse
 */
export interface AppPropsResponse {
    /**
     * 
     * @type {string}
     * @memberof AppPropsResponse
     */
    tokenTtl: string;
    /**
     * 
     * @type {number}
     * @memberof AppPropsResponse
     */
    minPasswordSize: number;
    /**
     * 
     * @type {string}
     * @memberof AppPropsResponse
     */
    passwordExpirationTime: string;
    /**
     * 
     * @type {string}
     * @memberof AppPropsResponse
     */
    profile: string;
}

export function AppPropsResponseFromJSON(json: any): AppPropsResponse {
    return AppPropsResponseFromJSONTyped(json, false);
}

export function AppPropsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppPropsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenTtl': json['tokenTtl'],
        'minPasswordSize': json['minPasswordSize'],
        'passwordExpirationTime': json['passwordExpirationTime'],
        'profile': json['profile'],
    };
}

export function AppPropsResponseToJSON(value?: AppPropsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tokenTtl': value.tokenTtl,
        'minPasswordSize': value.minPasswordSize,
        'passwordExpirationTime': value.passwordExpirationTime,
        'profile': value.profile,
    };
}

